import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export interface NewsItem {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  body: string;
  image: string;
  created_at: string;
  updated_at: string;
  featured: boolean;
  status: string;

  links: {
    single_screen_api: string;
  };
}

interface NewsCardProps {
  item: NewsItem;
}

const NewsCard: React.FC<NewsCardProps> = ({ item }) => {
  const date = new Date(item.created_at);

  return (
    <Link
      to={`/blogs/${item.slug}`}
      state={{ api: item.links.single_screen_api }}
      className="group bg-white rounded-xl overflow-hidden border border-gray-100 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 flex flex-col h-full"
    >
      {/* IMAGE */}
      <div className="relative shrink-0">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-48 object-cover group-hover:scale-110 transition duration-700"
        />

        {/* DATE */}
        <div className="absolute -bottom-6 left-5 bg-yellow-400 rounded-xl shadow-xl px-4 py-3 min-w-[78px] text-center">
          <h3 className="text-3xl font-extrabold text-black leading-none">
            {date.getDate()}
          </h3>

          <p className="text-sm font-bold text-black uppercase mt-1">
            {date.toLocaleString("default", {
              month: "short",
            })}
          </p>
        </div>

        {/* FEATURED */}
        {item.featured && (
          <div className="absolute top-4 right-4">
            <span className="bg-white/95 backdrop-blur text-sky-600 text-[11px] font-bold px-3 py-1 rounded-full shadow">
              ★ FEATURED
            </span>
          </div>
        )}
      </div>

      {/* CONTENT */}
      <div className="p-6 pt-8 flex-1 flex flex-col">
        <h2 className="text-xl  font-bold text-[#0A1F44] line-clamp-2 group-hover:text-blue-600 transition">
          {item.title}
        </h2>

        <p className="text-gray-600 mt-2 text-[15px] line-clamp-3">
          {item.excerpt}
        </p>

        {/* READ MORE + LINE */}
        <div className="mt-auto pt-4 flex w-full flex-col items-start">
          <div className="flex items-center gap-2 text-[#0A1F44] font-semibold group-hover:text-yellow-500 transition">
            Read More
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition duration-300" />
          </div>

          <div className="h-[4px] w-full bg-gradient-to-r from-yellow-400 via-orange-400 to-yellow-500 rounded-full mt-2" />
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;
